export const parseJson = (json) => {
    let obj;

    try {
        obj = JSON.parse(json);
    } catch(e) {
        obj = {} // handles exceptions
    }

    return obj;
}